import { Routes } from '@angular/router';
import { AuthGuard } from './guard/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.routes').then((m) => m.routes),
    canLoad: [AuthGuard],
  },
  {
    path: 'home-new',
    loadChildren: () => import('./pages/home-new/home-new.routes').then((m) => m.routes),
    canLoad: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.page').then( m => m.RegisterPage)
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.routes').then( m => m.routes),
    canLoad: [AuthGuard],
  },
  {
    path: 'products',
    loadChildren: () => import('./pages/products/products.routes').then( m => m.routes),
    canLoad: [AuthGuard],
  },
  {
    path: 'messages',
    loadChildren: () => import('./pages/messages/messages.routes').then( m => m.routes),
    canLoad: [AuthGuard],
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.routes').then( m => m.routes),
    canLoad: [AuthGuard],
  },
  {
    path: 'product-preview',
    loadChildren: () => import('./pages/product-preview/product-preview.routes').then( m => m.routes),
    canLoad: [AuthGuard],
  },
  {
    path: 'vendor-profile',
    loadComponent: () => import('./pages/profile/vendor-profile/vendor-profile.page').then( m => m.VendorProfilePage),
    canLoad: [AuthGuard],
  },
  {
    path: 'order-details',
    loadComponent: () => import('./pages/order-details/order-details.page').then( m => m.OrderDetailsPage),
    canLoad: [AuthGuard],
  },
  {
    path: 'order-details/:orderId',
    loadComponent: () => import('./pages/order-details/order-details.page').then( m => m.OrderDetailsPage),
    canLoad: [AuthGuard],
  },
  {
    path: 'service-details/:orderId',
    loadComponent: () => import('./pages/service-details/service-details.page').then( m => m.ServiceDetailsPage),
    canLoad: [AuthGuard],
  },
  {
    path: 'orders',
    loadComponent: () => import('./pages/orders/orders.page').then( m => m.OrdersPage),
    canLoad: [AuthGuard],
  },
  {
    path: 'tickets',
    loadComponent: () => import('./pages/profile/tickets/tickets.page').then( m => m.TicketsPage)
  },
  {
    path: 'ticket-orders',
    loadComponent: () => import('./pages/ticket-orders/ticket-orders.page').then( m => m.TicketOrdersPage)
  }
];
